import AddStepAction from './addStepAction.js';
import BaseStepAction from './BaseStepAction.js';
import Track from 'track/Track.js';

class DeleteStepAction extends BaseStepAction {
    constructor(sequencerEngine) {
        super(sequencerEngine);
    }

    // stepNumber can be a floating value, indicating
    // the unquantized offset
    // Any mutation of the step pattern for any track
    // which requires adding a step must come through here
    execute({track, step, stepNumber, resolution=Track.baseResolution}, updateRedux=true) {
        let wholeStepNumber = Math.floor(stepNumber);
        let position = stepNumber - wholeStepNumber;

        track.sequencerEngine.resolution = resolution;
        track.getEasyPattern()
            .deleteStepAtStepNumber(step, wholeStepNumber, resolution, updateRedux);

        if (updateRedux) {
            track.updateSteps();
        } else {
            track.pattern.needsSync = true;
        }
        return {};
    }

    undo(action) {
        // we instead add it back!
        let addStepAction = new AddStepAction(this.sequencerEngine);
        addStepAction.execute(
            action.payload.track,
            action.payload.step,
            action.payload.stepNumber,
            action.payload.resolution);
        action.payload.track.updateSteps();
    }

    getContentId({payload}) {
        return payload.step.id;
    }
}

export default DeleteStepAction;
